import React from 'react';

// Hoks
import { useApp } from 'Shared/utils/hooks/use-app';
import { usePITracking } from 'Shared/tracking/use-pi-tracking';

// Components
import { WpButton } from 'Wpds/components/button';
import PiSuggestedTopicsEmptyState from './PiSuggestedTopicsEmptyState';

// Styles
import './PiSuggestedTopicsNoInspireAccessState.scss';

type Props = {
  categoryDropdown: React.ReactNode;
};
const PiSuggestedTopicsNoInspireAccessState = ({ categoryDropdown }: Props) => {
  const { intercomContactSalesEventName } = useApp();
  const { trackContactSales } = usePITracking();

  const handleContactSalesClick = () => {
    trackContactSales({ component: 'PI suggested topics no inspire access component' });
  };

  const baseClassName = 'PiSuggestedTopicsNoInspireAccessState';
  return (
    <div>
      <div className={`${baseClassName}__toolbar`}>{categoryDropdown}</div>
      <PiSuggestedTopicsEmptyState
        title="Get personalized agenda topics in Perform"
        description="Contact your PI Consultant to add these topics to your account."
        actions={
          <WpButton
            variant="secondary"
            dataAttributes={{ 'data-intercom': intercomContactSalesEventName }}
            onClick={handleContactSalesClick}
          >
            Contact your consultant
          </WpButton>
        }
      />
    </div>
  );
};

export default PiSuggestedTopicsNoInspireAccessState;
